// extracted by mini-css-extract-plugin
export default {"link":"link-module__link__Ne04n","title":"link-module__title__GTNTj","desc":"link-module__desc__1UeA8"};